import { UAParser } from 'ua-parser-js';
import { cookieStorage } from '@mirohq-internal/website-utils';

// @TODO ua-parser-js is not exporting types correctly
// @ts-ignore
const getNetworkPayload = ()=>({
        connection_save_data: window.navigator.connection?.saveData,
        connection_speed_type: window.navigator.connection?.effectiveType
    });
const getGeoDataPayload = ()=>{
    const geoDataString = cookieStorage.get('geo_data');
    if (!geoDataString) {
        return {};
    }
    const geoDataParts = geoDataString.split('|');
    return {
        geo_country_code: geoDataParts[0],
        geo_country_name: geoDataParts[1],
        geo_city: geoDataParts[2],
        geo_timezone: geoDataParts[3]
    };
};
const getDeviceInfoPayload = ()=>{
    const uaResult = new UAParser().getResult().withFeatureCheck();
    return {
        device_type: uaResult.device.type || 'desktop',
        device_vendor: uaResult.device.vendor,
        device_model: uaResult.device.model,
        os_name: uaResult.os.name,
        os_version: uaResult.os.version,
        browser_name: uaResult.browser.name,
        browser_version_full: uaResult.browser.version,
        browser_version_major: uaResult.browser.major,
        device_cpu_arch: uaResult.cpu.architecture,
        device_cpu_cores: window.navigator.hardwareConcurrency,
        device_memory: window.navigator.deviceMemory
    };
};
const getServiceInfoPayload = ()=>({
        app_service_name: process.env['NEXT_PUBLIC_SERVICE_NAME'],
        app_service_version: process.env['NEXT_PUBLIC_SERVICE_VERSION']
    });
const getCommonPayload = ()=>({
        ...getNetworkPayload(),
        ...getGeoDataPayload(),
        ...getDeviceInfoPayload(),
        ...getServiceInfoPayload()
    });

export { getCommonPayload, getDeviceInfoPayload, getGeoDataPayload, getNetworkPayload, getServiceInfoPayload };
